const u = (n) => {
  const [t, r, s] = n.match(/\w\w/g).map((o) => parseInt(o, 16));
  return [t, r, s];
};
function l(n, t) {
  try {
    if (n.indexOf("#") === 0 && (n = n.slice(1)), n.length === 3 && (n = n[0] + n[0] + n[1] + n[1] + n[2] + n[2]), n.length !== 6)
      throw new Error("Invalid HEX color.");
    var r = parseInt(n.slice(0, 2), 16), s = parseInt(n.slice(2, 4), 16), o = parseInt(n.slice(4, 6), 16);
    return t ? r * 0.299 + s * 0.587 + o * 0.114 > 186 ? "#000000" : "#FFFFFF" : (r = (255 - r).toString(16), s = (255 - s).toString(16), o = (255 - o).toString(16), "#" + e(r) + e(s) + e(o));
  } catch (i) {
    return console.error(i), n;
  }
}
function e(n, t = 2) {
  return (new Array(t).join("0") + n).slice(-t);
}
const p = (n, t) => {
  const [r, s, o] = u(n);
  return `rgb(${r - r * t}, ${s - s * t}, ${o - o * t})`;
};
function E(n, t) {
  const r = n.replace("#", ""), s = parseInt(r.substring(0, 2), 16), o = parseInt(r.substring(2, 4), 16), i = parseInt(r.substring(4, 6), 16), a = Math.min(255, Math.round(s + (255 - s) * t)), F = Math.min(255, Math.round(o + (255 - o) * t)), g = Math.min(255, Math.round(i + (255 - i) * t));
  return `#${((1 << 24) + (a << 16) + (F << 8) + g).toString(16).slice(1)}`;
}
function c(n, t) {
  const r = n.replace("#", ""), s = parseInt(r.substring(0, 2), 16), o = parseInt(r.substring(2, 4), 16), i = parseInt(r.substring(4, 6), 16);
  return `rgba(${s}, ${o}, ${i}, ${t})`;
}
const B = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
  5008: c("#919EAB", 0.08),
  50012: c("#919EAB", 0.12),
  50016: c("#919EAB", 0.16),
  50024: c("#919EAB", 0.24),
  50032: c("#919EAB", 0.32),
  50048: c("#919EAB", 0.48),
  50056: c("#919EAB", 0.56),
  50080: c("#919EAB", 0.8)
};
export {
  B as GREY,
  c as alpha,
  p as darken,
  l as getContrastColor,
  u as hex2rgb,
  E as lighten
};
